import { useState } from "react";
import { useNightMode } from "../../../contexts/NightModeContext";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { toHaveDescription } from "@testing-library/jest-dom/matchers";
type CardData = {
  name?: string;
  icon?: string;
  iconImage?: string | File;
  ticket?: string;
  startDate: string;
  status?: string;
  totalUsed?: number;
  totalLimit?: number;
  optionHead?: string;
  option?: string;
  optionHead1?: string;
  option1?: string;
  optionHead2?: string;
  option2?: string;
  optionIcon2?: string;
  optionHead3?: string;
  option3?: string;
  optionIcon3?: string;
  optionHead4?: string;
  option4?: string;
  optionIcon4?: string;
  discount?: string;
  isActive?: boolean;
  optionIcon1?: string;
  description?: string;
  link?: string;
  ticketGroup?: string;
  date?: string;
  hasStatusCtrl?: boolean;
};

type ListCardProps = {
  cardData: CardData;
  onEdit?: () => void;
  onDelete?: () => void;
  onToggle?: (isActive: boolean) => void;
  hasStatusCtrl?: boolean;

};
const ListCard = ({ cardData, onEdit, onDelete, onToggle,hasStatusCtrl=false }: ListCardProps) => {  const {
    name,
    icon,
    iconImage,
    ticket,
    startDate,
    status,
    totalUsed,
    totalLimit,
    optionHead,
    option,
    optionHead1,
    option1,
    optionIcon1,
    optionHead2,
    option2,
    optionIcon2,
    optionHead3,
    option3,
    optionIcon3,
    optionHead4,
    option4,
    optionIcon4,
    date,
    discount,
    isActive = true,    
    description,
    link,
    ticketGroup,
  } = cardData;
  const safeStatus = (status || "").toLowerCase();
  const statusColor = safeStatus === "active" ? "green" : safeStatus === "inactive" ? "red" : safeStatus === "hidden" ? "gray" : safeStatus === "sold-out" ? "orange" : "orange";;

  const [active, setActive] = useState(isActive);
  const { isNightMode } = useNightMode();
  const eventData: any = JSON.parse(localStorage.getItem("eventData") || "{}");


  const handleToggle = () => {
    const newState = !active;
    setActive(newState);
    if (onToggle) onToggle(newState);
  };
  let iconSrc: string | undefined;

    if (iconImage instanceof File) {
    iconSrc = URL.createObjectURL(iconImage); 
    } else {
    iconSrc = iconImage; 
    }


  return (
    <div className="all-promotion-list">
      <div className="glass-panel mt-2 mt-md-3 p-0 overflow-hidden">
        <div className="contact-list coupon-active">
          <div className="top d-flex flex-row justify-content-between align-items-start pt-3 pb-2 px-3 p-md-4 border_bottom gap-3">
            <div className="d-flex align-items-start gap-2 gap-md-3 flex-grow-1 min-w-0">
              <div className="flex-shrink-0">
                {iconImage ? (
                  <img
                    src={iconSrc}
                    alt={name}
                    className="icon-big icon icon-purple"
                    style={{
                      width: "36px",
                      height: "36px",
                      minWidth: "36px",
                      fontSize: "14px",
                      position: "static",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: 0,
                    }}
                  />
                ) : (
                  <span
                    className={`icon-big ${icon === "fa-solid fa-ticket" ? "rotate-icon" : ""} icon icon-purple`}
                    style={{
                      width: "36px",
                      height: "36px",
                      minWidth: "36px",
                      fontSize: "14px",
                      position: "static",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: 0,
                    }}
                  >
                    <i className={icon}></i>
                  </span>
                )}
              </div>
              <div className="flex-grow-1 min-w-0">
                <h5 className="font-18 mb-1 f-weight-medium text-wrap text-break m-0">{name}</h5>
                {ticket && (
                  <p className="text-gray-50 m-0 small">{ticket}</p>
                )}
                {description && (
                  <p className="text-gray-50 m-0 small mt-1 text-wrap text-break">{description}</p>
                )}
                {link && (
                  <p className="text-gray-50 m-0 small mt-1 text-break">
                    <span className="text-white-50 me-1">Link:</span>
                    <span
                      role="button"
                      className="text-blue-400 underline break-all cursor-pointer"
                      onClick={() => {
                        if (link) {
                          navigator.clipboard.writeText(link);
                        }
                      }}
                    >
                      {link}
                    </span>
                  </p>
                )}
                <div className="d-flex flex-wrap gap-x-2 gap-y-1 mt-2 text-gray-50 small">
                  <span>Added: <FormattedDate dateString={startDate} /></span>
                  {ticketGroup && (
                    <span>• Group: {ticketGroup}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center ms-auto flex-shrink-0">
              <div className="dropdown dropdown-default dropdown-text dropdown-icon-item">
                <button className="option-btn-1" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <div className="dropdown-menu dropdown-menu-right">
                  {onEdit && (
                    <button className="dropdown-item" type="button" onClick={onEdit}>
                      <i className="fa-solid fa-pen me-3"></i>Edit
                    </button>
                  )}
                  {onDelete && (
                    <button className="dropdown-item" type="button" onClick={onDelete}>
                      <i className="fa-solid fa-trash-can me-3"></i>Delete
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="bottom d-flex flex-row flex-wrap pt-2 pb-3 px-3 p-md-4" style={{ gap: "12px 24px" }}>
            {status && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                {hasStatusCtrl ? (
                  <label className="btn-switch m-0 me-1 flex-shrink-0">
                    <input
                      type="checkbox"
                      checked={isActive}
                      onChange={(e) => onToggle && onToggle(e.target.checked)}
                    />
                    <span className="checkbox-slider"></span>
                  </label>
                ) : (
                  <i className="fa-regular fa-circle-dot text-white-50" style={{ fontSize: "12px" }}></i>
                )}
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">Status:</span>
                  <h6 className="coupon-status d-flex align-items-center m-0 font-jakarta f-weight-medium small">
                    <i
                      className="fa-solid fa-circle me-1"
                      style={{
                        fontSize: "6px",
                        color:
                          safeStatus === "hidden"
                            ? "gray"
                            : safeStatus === "sold-out"
                            ? "orange"
                            : isActive
                            ? "green"
                            : "red",
                      }}
                    ></i>
                    {safeStatus === "hidden"
                      ? "Hidden"
                      : safeStatus === "sold-out"
                      ? "Sold Out"
                      : isActive
                      ? "Active"
                      : "Inactive"}
                  </h6>
                </div>
              </div>
            )}
            {totalLimit !== undefined && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className="fa-solid fa-chart-column text-white-50" style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">Limit:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">
                    {totalUsed ?? 0} / {totalLimit === 0 || totalLimit === null ? "Unlimited" : totalLimit}
                  </h6>
                </div>
              </div>
            )}
            {optionHead && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className="fa-solid fa-tag text-white-50" style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">{optionHead}:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">{option}</h6>
                </div>
              </div>
            )}
            {optionHead1 && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className={`${optionIcon1} text-white-50`} style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">{optionHead1}:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">{option1}</h6>
                </div>
              </div>
            )}
            {optionHead2 && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className={`${optionIcon2} text-white-50`} style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">{optionHead2}:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">{option2}</h6>
                </div>
              </div>
            )}
            {optionHead3 && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className={`${optionIcon3 || "fa-solid fa-ticket"} text-white-50`} style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">{optionHead3}:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">{option3}</h6>
                </div>
              </div>
            )}
            {optionHead4 && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className={`${optionIcon4 || "fa-solid fa-coins"} text-white-50`} style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">{optionHead4}:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">{option4}</h6>
                </div>
              </div>
            )}
            {date && (
              <div className="d-flex align-items-center" style={{ minWidth: 0, gap: "6px" }}>
                <i className="fa-solid fa-calendar text-white-50" style={{ fontSize: "12px" }}></i>
                <div className="d-flex flex-row align-items-center" style={{ gap: "4px", whiteSpace: "nowrap" }}>
                  <span className="text-gray-50 small m-0">Date:</span>
                  <h6 className="coupon-status m-0 font-jakarta f-weight-medium small">{date}</h6>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListCard;